module.exports = __webpack_public_path__ + "images/8cfec0c06196087f6760b517ef848804.svg";